// Section Product Tabs

class TabsAutomatic {
	constructor(groupNode) {
	  this.tablistNode = groupNode;

	  this.tabs = [];

	  this.firstTab = null;
	  this.lastTab = null;

	  this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
	  this.tabpanels = [];

	  for (var i = 0; i < this.tabs.length; i += 1) {
		var tab = this.tabs[i];
		var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

		tab.tabIndex = -1;
		tab.setAttribute('aria-selected', 'false');
		this.tabpanels.push(tabpanel);

		tab.addEventListener('keydown', this.onKeydown.bind(this));
		tab.addEventListener('click', this.onClick.bind(this));

		if (!this.firstTab) {
		  this.firstTab = tab;
		}
		this.lastTab = tab;
	  }

	  this.setSelectedTab(this.firstTab, false);
	}

	setSelectedTab(currentTab, setFocus) {
	  if (typeof setFocus !== 'boolean') {
		setFocus = true;
	  }
	  for (var i = 0; i < this.tabs.length; i += 1) {
		var tab = this.tabs[i];
		if (currentTab === tab) {
		  tab.setAttribute('aria-selected', 'true');
		  tab.removeAttribute('tabindex');
		  this.tabpanels[i].classList.remove('is-hidden');
		  if (setFocus) {
			tab.focus();
		  }
		} else {
		  tab.setAttribute('aria-selected', 'false');
		  tab.tabIndex = -1;
		  this.tabpanels[i].classList.add('is-hidden');
		}
	  }
	}

	setSelectedToPreviousTab(currentTab) {
	  var index;

	  if (currentTab === this.firstTab) {
		this.setSelectedTab(this.lastTab);
	  } else {
		index = this.tabs.indexOf(currentTab);
		this.setSelectedTab(this.tabs[index - 1]);
	  }
	}

	setSelectedToNextTab(currentTab) {
	  var index;

	  if (currentTab === this.lastTab) {
		this.setSelectedTab(this.firstTab);
	  } else {
		index = this.tabs.indexOf(currentTab);
		this.setSelectedTab(this.tabs[index + 1]);
	  }
	}

	/* EVENT HANDLERS */

	onKeydown(event) {
	  var tgt = event.currentTarget,
		flag = false;

	  switch (event.key) {
		case 'ArrowLeft':
		  this.setSelectedToPreviousTab(tgt);
		  flag = true;
		  break;

		case 'ArrowRight':
		  this.setSelectedToNextTab(tgt);
		  flag = true;
		  break;

		case 'Home':
		  this.setSelectedTab(this.firstTab);
		  flag = true;
		  break;

		case 'End':
		  this.setSelectedTab(this.lastTab);
		  flag = true;
		  break;

		default:
		  break;
	  }

	  if (flag) {
		event.stopPropagation();
		event.preventDefault();
	  }
	}

	onClick(event) {
	  this.setSelectedTab(event.currentTarget);
	}
  }

  // Initialize tablist

  window.addEventListener('load', function () {
	var tablists = document.querySelectorAll('[role=tablist].automatic');
	for (var i = 0; i < tablists.length; i++) {
	  new TabsAutomatic(tablists[i]);
	}
  });

const productTabs = document.querySelectorAll('.product-tabs');
// if (productTabs) {
// 	const tabs = productTabs.querySelectorAll('[role="tabpanel"]');
// 	tabs.forEach(function(section) {
// 		let title = section.querySelector('h3');
// 		title.classList.add('mobile');
// 		title.addEventListener('click', function(e) {
// 			e.preventDefault();

// 		});
// 	});
// }

function mobileTabPanel() {
	if (window.matchMedia("(min-width: 768px)").matches) {
		if(productTabs.length) {
			productTabs.forEach(function(group) {
				const tabs = group.querySelectorAll('[role="tabpanel"]');
				tabs.forEach(function(section) {
					let title = section.querySelector('h3');
					title.classList.remove('mobile');
					title.classList.remove('active');
					title.removeEventListener('click', function(e) {
					});
				});
			});
		}
	} else {
		console.log("Screen less than 500px")
		if(productTabs.length) {
			productTabs.forEach(function(group) {
				const tabs = group.querySelectorAll('[role="tabpanel"]');
				tabs.forEach(function(section) {
					console.log("how many");
					let title = section.querySelector('h3');

					if (!title.classList.contains('mobile')) {
						title.classList.add('mobile');
						title.addEventListener('click', function(e) {
							e.preventDefault();
							title.classList.toggle('active');
							console.log('clicked');
						});
					}
				});

			});
		}
	}
}
mobileTabPanel();

windowResize.add( mobileTabPanel );

var featuredCarousel = new Swiper(".my-featured-carousel", {
	watchOverflow: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	preventInteractionOnTransition: true,
	effect: 'slide',
	loop: true,
	autoplay: {
		delay: 8000,
		disableOnInteraction: true,
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	  }
	});

var storyCarousel = new Swiper(".story-carousel", {
	watchOverflow: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	preventInteractionOnTransition: true,
	effect: 'slide',
	loop: true,
	autoplay: {
		delay: 8000,
		disableOnInteraction: true,
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	  }
	});

// Collection accordion toggle
const accordionButtons = document.querySelectorAll('.accordion button');
if (accordionButtons.length) {
	accordionButtons.forEach(function(item) {
		item.addEventListener('click', function(e) {
			let submenu = item.parentElement.querySelector('ul');
			console.log(submenu);
			item.parentElement.classList.toggle('active');
			submenu.classList.toggle('active');
		});
	});
}
// 	$('.accordion button').click(function() {
//     	$(this).parent().toggleClass('active');
//     	$(this).next().slideToggle();
//   });